import { render, staticRenderFns } from "./form-date.vue?vue&type=template&id=4f137a24&scoped=true&"
import script from "./form-date.vue?vue&type=script&lang=js&"
export * from "./form-date.vue?vue&type=script&lang=js&"
import style0 from "./form-date.vue?vue&type=style&index=0&id=4f137a24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f137a24",
  null
  
)

export default component.exports